import { createSlice } from "@reduxjs/toolkit";
import { getPrintingPlanList } from "../../reduxApi/admin/PrinitingPlanReduxApi";
const PrintingPlanSlice = createSlice({
    name: "PrintingPlan",
    initialState: {
        status: "idle",
        isFiltered: false,
        PrintingPlan: [],
    },

    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },

        deletePrintingPlanAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.PrintingPlan.findIndex(
                    (item) => item.ROWID === id
                );

                if (index !== -1) {
                    state.PrintingPlan.splice(index, 1);
                }
            });
        },

        updatePrintingPlanAction: (state, action) => {
            const { ROWID, payload } = action.payload;
            const index = state.PrintingPlan.findIndex(
                (item) => item.ROWID === action.payload.ROWID
            );
            console.log("state.PrintingPlan[index] before", state.PrintingPlan[index])
            if (index !== -1) {
                state.PrintingPlan[index] = {
                    ...state.PrintingPlan[index],
                    ...payload
                };
            }
            console.log("state.PrintingPlan[index] after", state.PrintingPlan[index])

        },

        addPrintingPlanAction: (state, action) => {
            state.PrintingPlan.unshift(action.payload);
        },

        clearFilters: (state) => {
            state.isFiltered = false;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(getPrintingPlanList.pending, (state) => {
                state.status = "pending";
            })

            .addCase(getPrintingPlanList.fulfilled, (state, action) => {
                state.status = "fulfilled";
                console.log("printing plan action", action)
                state.PrintingPlan = action.payload?.data
            })

            .addCase(getPrintingPlanList.rejected, (state) => {
                state.status = "rejected";
            });
    },
});

export const {
    deletePrintingPlanAction,
    updatePrintingPlanAction,
    addPrintingPlanAction,
    setFilteredStatus,
    clearFilters,
} = PrintingPlanSlice.actions;

export default PrintingPlanSlice.reducer;